import firebase from 'firebase/app'
import 'firebase/firestore'
var firebaseConfig = {
    apiKey: "AIzaSyB4Wc8SVxoPB6-yn7NYLwGBLgJ4CwlwD-M",
    authDomain: "delvalleconstructionllc170.firebaseapp.com",
    databaseURL: "https://delvalleconstructionllc170.firebaseio.com",
    projectId: "delvalleconstructionllc170",
    storageBucket: "delvalleconstructionllc170.appspot.com",
    messagingSenderId: "459188181281",
    appId: "1:459188181281:web:3854ec794fc23d55190660",
    measurementId: "G-E3XYQD3872"
  };
  // Initialize Firebase
  const fb = firebase.initializeApp(firebaseConfig);
  export const db = fb.firestore()